(() => {
  'use strict';

  const SCRIPT_ID = 'fmm-interaction-bundle';
  const SCRIPT_SRC = '/assets/js/interaction-v63.js?v=156.26';
  const CONSENT_KEY = 'fmmConsentV61';
  const ON_DEMAND_SELECTOR = '[data-lightbox],.gallery-button,.project-shot,.project-readme img,.rich-readme img,[data-open-privacy-settings],#fmmPrivacyManage';
  let scriptPromise = null;

  function normalizeConsent(value) {
    if (!value || typeof value !== 'object') return null;
    const choice = value.choice || value.level || value.mode;
    if (!choice) return null;
    return {
      ...value,
      choice: choice === true || choice === 'all' || choice === 'accept-all' || choice === 'accepted-all' ? 'all' : 'essential'
    };
  }

  function readConsentCookie() {
    const prefix = `${CONSENT_KEY}=`;
    const match = document.cookie.split('; ').find(item => item.startsWith(prefix));
    if (!match) return null;
    try {
      return normalizeConsent(JSON.parse(decodeURIComponent(match.slice(prefix.length))));
    } catch {
      return null;
    }
  }

  function sharedCookieDomain() {
    const host = String(location.hostname || '').toLowerCase();
    return host === 'freeminecraftmods.com' || host === 'www.freeminecraftmods.com'
      ? '.freeminecraftmods.com'
      : '';
  }

  function writeConsentCookie(value) {
    if (!value) return;
    const encoded = encodeURIComponent(JSON.stringify(value));
    const base = `${CONSENT_KEY}=${encoded}; Max-Age=15552000; Path=/; SameSite=Lax${location.protocol === 'https:' ? '; Secure' : ''}`;
    try {
      document.cookie = base;
      const domain = sharedCookieDomain();
      if (domain) document.cookie = `${base}; Domain=${domain}`;
    } catch {
      // Cookie writes are best-effort; localStorage can still carry the choice.
    }
  }

  function readSavedConsent() {
    try {
      const stored = normalizeConsent(JSON.parse(localStorage.getItem(CONSENT_KEY) || 'null'));
      if (stored) {
        writeConsentCookie(stored);
        return stored;
      }
    } catch {
      // Storage is optional; the first-party cookie fallback keeps the choice durable.
    }

    const cookieValue = readConsentCookie();
    if (cookieValue) {
      try {
        localStorage.setItem(CONSENT_KEY, JSON.stringify(cookieValue));
      } catch {
        // Storage may be blocked, but the cookie still prevents repeated prompts.
      }
    }
    return cookieValue;
  }

  function hasSavedConsent() {
    return Boolean(readSavedConsent());
  }

  function installImageRecovery() {
    document.addEventListener('error', event => {
      const image = event.target;
      if (!(image instanceof HTMLImageElement)) return;
      if (image.closest('[data-browse-project-grid],#creatorGrid')) return;

      const fallback = String(image.dataset.fallbackSrc || '').trim();
      if (fallback && image.dataset.fallbackAttempted !== 'true') {
        image.dataset.fallbackAttempted = 'true';
        image.src = fallback;
        return;
      }

      image.hidden = true;
      const sibling = image.nextElementSibling;
      if (sibling && (sibling.matches('[data-image-fallback]') || sibling.classList.contains('project-placeholder'))) {
        sibling.hidden = false;
      }
    }, true);
  }

  installImageRecovery();

  function loadInteractionBundle() {
    if (scriptPromise) return scriptPromise;
    const existing = document.getElementById(SCRIPT_ID);
    if (existing) return Promise.resolve();

    scriptPromise = new Promise(resolve => {
      const script = document.createElement('script');
      script.id = SCRIPT_ID;
      script.src = SCRIPT_SRC;
      script.defer = true;
      script.addEventListener('load', resolve, { once: true });
      script.addEventListener('error', resolve, { once: true });
      document.head.appendChild(script);
    });
    return scriptPromise;
  }

  // Keep image previews and explicit privacy controls responsive before the idle load.
  document.addEventListener('click', event => {
    if (event.__fmmInteractionReplay) return;
    const target = event.target.closest?.(ON_DEMAND_SELECTOR);
    if (!target || document.getElementById(SCRIPT_ID)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    loadInteractionBundle().then(() => {
      const replay = new MouseEvent('click', { bubbles: true, cancelable: true, view: window });
      Object.defineProperty(replay, '__fmmInteractionReplay', { value: true });
      target.dispatchEvent(replay);
    });
  }, true);

  if (!hasSavedConsent()) {
    if ('requestIdleCallback' in window) requestIdleCallback(loadInteractionBundle, { timeout: 1000 });
    else window.setTimeout(loadInteractionBundle, 200);
    return;
  }

  const delayedLoad = () => {
    window.setTimeout(() => {
      if ('requestIdleCallback' in window) requestIdleCallback(loadInteractionBundle, { timeout: 5000 });
      else loadInteractionBundle();
    }, 9000);
  };

  if (document.readyState === 'complete') delayedLoad();
  else window.addEventListener('load', delayedLoad, { once: true, passive: true });
})();
